import React from 'react';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import PaymentHistoryActionsModuleView from 'partial/OfferManager/modules/PaymentHistoryActionsModule/PaymentHistoryActionsModuleView';
import { useSelector } from 'react-redux';

const PaymentHistoryActionsModuleController = props => {
  const { additionalData, history, eventHandler } = props;
  const { paymentHistoryContainer, selectedFactor } = useSelector(state => ({
    paymentHistoryContainer:
      state?.paymentHistoryContainer?.paymentHistoryContainer,
    selectedFactor: state?.score1b3bFactorDial?.factor?.selectedFactor,
  }));
  const loading = props.globalLoadingFlag;
  if (loading) {
    return <PageLoadingMask description={'Loading...'} />;
  } else {
    return (
      <PaymentHistoryActionsModuleView
        additionalData={additionalData}
        history={history}
        paymentHistoryContainer={paymentHistoryContainer}
        selectedFactor={selectedFactor}
        eventHandler={eventHandler}
        config={props.config}
      />
    );
  }
};

export default PaymentHistoryActionsModuleController;
